import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useState } from "react";
import "../styles/dashboard.css";

const Login = () => {
  const { loginUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Login without role selection → default role = User
    loginUser(
      { name: form.name, email: form.email },
      "User"
    );

    navigate("/dashboard");
  };

  return (
    <div className="page-container centered-page">
      <div className="login-card">
        <h1>Sign in</h1>
        <p className="login-subtitle">
          Enter your name & email to continue
        </p>
        <form onSubmit={handleSubmit} className="login-form">
          <label>
            Name
            <input
              name="name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </label>
          <label>
            Email
            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </label>

          <button type="submit" className="btn-primary full-width">
            Continue
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
